module.exports = __webpack_public_path__ + "img/earthbound.affa687f.png";